import { toggleMenu } from "./header";
import { scrollToHash, getSamePageAnchor } from "./smooth-scrolling";
import '../css/main.css';


document.addEventListener("DOMContentLoaded", () => {
  /**
   * Toggle del header
   */
  toggleMenu()

  /**
   * Example carousel import
   */
  const carousel = document.querySelectorAll(".carousel");
  if (carousel.length > 0) {
    import("./carousel").then((module) => {
      carousel.forEach((slider) => {
        module.carousel(slider);
      });
    });
  }

  /**
   * Smooth scrolling support
   */
  // If a link's href is within the current page, scroll to it instead
  document.querySelectorAll('a[href]').forEach(a => {
    a.addEventListener('click', e => {
      scrollToHash(getSamePageAnchor(a), e);
    });
  });
  // Scroll to the element in the URL's hash on load
  scrollToHash(window.location.hash);

  /**
   * Header scroll behavior
   */
  const header = document.getElementById('masthead');
  if (header) {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
    };
    window.addEventListener('scroll', handleScroll);
    handleScroll();
  }

  /**
   * FAQ accordion (single open)
   */
  const accordions = document.querySelectorAll('[data-accordion="single"]');
  accordions.forEach((accordion) => {
    const items = accordion.querySelectorAll('[data-accordion-item]');

    const setItemState = (item, isOpen) => {
      const trigger = item.querySelector('[data-accordion-trigger]');
      const content = item.querySelector('[data-accordion-content]');

      item.setAttribute('data-state', isOpen ? 'open' : 'closed');
      if (trigger) {
        trigger.setAttribute('data-state', isOpen ? 'open' : 'closed');
        trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      }
      if (content) {
        content.setAttribute('data-state', isOpen ? 'open' : 'closed');
        content.style.height = isOpen ? `${content.scrollHeight}px` : '0px';
      }
    };

    items.forEach((item) => {
      const content = item.querySelector('[data-accordion-content]');
      if (content) {
        content.style.height = '0px';
      }

      const trigger = item.querySelector('[data-accordion-trigger]');
      if (!trigger) return;

      trigger.addEventListener('click', () => {
        const isOpen = item.getAttribute('data-state') === 'open';
        items.forEach((other) => {
          setItemState(other, other === item ? !isOpen : false);
        });
      });
    });
  });

  /**
   * ACF7 event listener
   */
  document.addEventListener('wpcf7mailsent', (event) => {
    gtag('event', 'Formulario', {
      'event_category': event.detail.contactFormId,
      'event_label': event.detail.unitTag
    });
  }, false);

  const projectsCarousels = document.querySelectorAll('.projects-carousel');
  if (projectsCarousels.length > 0) {
    import("./projects-carousel").then((module) => {
      projectsCarousels.forEach((slider) => {
        module.carousel(slider);
      });
    });
  }
});




